import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  HiOutlineShoppingCart, HiOutlineEye, HiOutlineCog, HiOutlineCalendar,
  HiOutlineCurrencyDollar, HiOutlineUserGroup, HiOutlineClipboardList,
  HiOutlineCheckCircle, HiOutlineClock, HiOutlineTruck, HiOutlineCheck,
  HiOutlineX, HiOutlineArrowRight, HiOutlineExclamationCircle,
  HiOutlineDocumentDownload, HiOutlineFilter, HiOutlineRefresh,
  HiOutlinePencil, HiOutlineTrash, HiOutlineChevronDown, HiOutlineChevronUp,
  HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineChatAlt2,
  HiOutlineBell, HiOutlineDocumentText, HiOutlineCash,
  HiOutlineArrowUp, HiOutlineArrowDown, HiOutlineSwitchHorizontal
} from 'react-icons/hi';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';

export default function SatislarPage() {
  // ---- Mevcut state'ler ----
  const [sales, setSales] = useState([]);
  const [partners, setPartners] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [detailSale, setDetailSale] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [partnerFilter, setPartnerFilter] = useState("all");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [paymentNotes, setPaymentNotes] = useState("");

  // ---- YENİ: Tarih Aralığı Filtresi ----
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [dateField, setDateField] = useState("order_date"); // order_date | delivery_date
  const [showFilters, setShowFilters] = useState(false);

  // ---- YENİ: Sıralama ----
  const [sortField, setSortField] = useState("created_at");
  const [sortDirection, setSortDirection] = useState("desc");

  // ---- YENİ: Sayfalama ----
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);

  // ---- YENİ: Toplu İşlem ----
  const [selectedSaleIds, setSelectedSaleIds] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkStatus, setBulkStatus] = useState("");

  // ---- YENİ: Excel/PDF Dışa Aktarma ----
  const [showExportMenu, setShowExportMenu] = useState(false);

  // ---- YENİ: Aktivite Geçmişi ----
  const [activityLogs, setActivityLogs] = useState([]);
  const [newNote, setNewNote] = useState("");
  const [detailTab, setDetailTab] = useState("info"); // info | items | payments | history

  // ---- YENİ: Ödeme Takip ----
  const [paidAmount, setPaidAmount] = useState("");

  // ---- YENİ: Durum güncelleme loading ----
  const [statusUpdating, setStatusUpdating] = useState(null);

  // ---- YENİ: Toast bildirim ----
  const [toast, setToast] = useState(null);

  const showToast = (message, type = "success") => {
    setToast({ message, type });
    setTimeout(() => setToast(null), 3000);
  };

  // ======================== VERİ YÜKLEME ========================
  const loadSales = useCallback(() => {
    fetch('/api/sales')
      .then(res => res.json())
      .then(data => setSales(Array.isArray(data) ? data : []))
      .catch(() => setSales([]));
  }, []);

  useEffect(() => {
    loadSales();
    fetch('/api/partners')
      .then(res => res.json())
      .then(data => setPartners(data))
      .catch(() => setPartners([]));
  }, [loadSales]);

  // ======================== FİLTRELEME + SIRALAMA ========================
  const filteredAndSortedSales = useMemo(() => {
    let result = sales.filter(sale => {
      // Metin arama
      const matchesSearch = !searchTerm ||
        sale.sale_no?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.partner_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.notes?.toLowerCase().includes(searchTerm.toLowerCase());

      // Durum filtresi
      const matchesStatus = statusFilter === "all" || sale.status === statusFilter;

      // Partner filtresi
      const matchesPartner = partnerFilter === "all" || sale.partner_id?.toString() === partnerFilter;

      // Tarih aralığı filtresi
      let matchesDate = true;
      if (dateFrom || dateTo) {
        const saleDate = new Date(sale[dateField]);
        if (dateFrom) {
          matchesDate = matchesDate && saleDate >= new Date(dateFrom);
        }
        if (dateTo) {
          const toDate = new Date(dateTo);
          toDate.setHours(23, 59, 59);
          matchesDate = matchesDate && saleDate <= toDate;
        }
      }

      return matchesSearch && matchesStatus && matchesPartner && matchesDate;
    });

    // Sıralama
    result.sort((a, b) => {
      let valA = a[sortField];
      let valB = b[sortField];

      if (sortField === 'total_amount') {
        valA = Number(valA) || 0;
        valB = Number(valB) || 0;
      } else if (sortField === 'order_date' || sortField === 'delivery_date' || sortField === 'created_at') {
        valA = valA ? new Date(valA).getTime() : 0;
        valB = valB ? new Date(valB).getTime() : 0;
      } else {
        valA = (valA || '').toString().toLowerCase();
        valB = (valB || '').toString().toLowerCase();
      }

      if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    return result;
  }, [sales, searchTerm, statusFilter, partnerFilter, dateFrom, dateTo, dateField, sortField, sortDirection]);

  // ======================== SAYFALAMA ========================
  const totalPages = Math.ceil(filteredAndSortedSales.length / itemsPerPage);
  const paginatedSales = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return filteredAndSortedSales.slice(start, start + itemsPerPage);
  }, [filteredAndSortedSales, currentPage, itemsPerPage]);

  // Filtre değiştiğinde sayfa 1'e dön
  useEffect(() => { setCurrentPage(1); }, [searchTerm, statusFilter, partnerFilter, dateFrom, dateTo, dateField]);

  // ======================== GECİKME KONTROLÜ ========================
  const isOverdue = (sale) => {
    if (!sale.delivery_date) return false;
    if (sale.status === 'delivered' || sale.status === 'cancelled') return false;
    return new Date(sale.delivery_date) < new Date();
  };

  const daysOverdue = (sale) => {
    if (!isOverdue(sale)) return 0;
    const diff = new Date() - new Date(sale.delivery_date);
    return Math.ceil(diff / (1000 * 60 * 60 * 24));
  };

  const overdueCount = useMemo(() => sales.filter(isOverdue).length, [sales]);

  // ======================== SIRALAMA FONKSİYONU ========================
  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const SortIcon = ({ field }) => {
    if (sortField !== field) return <HiOutlineSwitchHorizontal className="w-3 h-3 text-gray-400 ml-1" />;
    return sortDirection === 'asc'
      ? <HiOutlineArrowUp className="w-3 h-3 text-blue-600 ml-1" />
      : <HiOutlineArrowDown className="w-3 h-3 text-blue-600 ml-1" />;
  };

  // ======================== DETAY MODALI ========================
  const handleShowDetail = async (sale) => {
    try {
      const resp = await fetch(`/api/sales/${sale.id}`);
      const data = await resp.json();
      setDetailSale(data);
      setDetailTab("info");
      setShowDetail(true);
      // Aktivite geçmişini yükle
      loadActivityLogs(sale.id);
    } catch (err) {
      showToast('Satış detayı yüklenemedi: ' + err.message, 'error');
    }
  };

  // ======================== AKTİVİTE GEÇMİŞİ ========================
  const loadActivityLogs = async (saleId) => {
    try {
      const resp = await fetch(`/api/sales/${saleId}/history`);
      if (resp.ok) {
        const data = await resp.json();
        setActivityLogs(data);
      } else {
        setActivityLogs([]);
      }
    } catch {
      setActivityLogs([]);
    }
  };

  const handleAddNote = async () => {
    if (!detailSale || !newNote.trim()) return;
    try {
      const resp = await fetch(`/api/sales/${detailSale.id}/notes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: newNote.trim() })
      });
      if (resp.ok) {
        setNewNote("");
        loadActivityLogs(detailSale.id);
        showToast('Not başarıyla eklendi!');
      }
    } catch (err) {
      showToast('Not eklenemedi: ' + err.message, 'error');
    }
  };

  // ======================== İNLINE DURUM DEĞİŞTİRME ========================
  const handleInlineStatusChange = async (saleId, newStatus) => {
    setStatusUpdating(saleId);
    try {
      const resp = await fetch(`/api/sales/${saleId}/status`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      });
      if (!resp.ok) throw new Error('Durum güncellenemedi');
      loadSales();
      showToast('Sipariş durumu güncellendi!');
    } catch (err) {
      showToast('Durum güncellenemedi: ' + err.message, 'error');
    } finally {
      setStatusUpdating(null);
    }
  };

  // ======================== TOPLU İŞLEM ========================
  const handleSelectAll = (checked) => {
    if (checked) {
      setSelectedSaleIds(paginatedSales.map(s => s.id));
    } else {
      setSelectedSaleIds([]);
    }
  };

  const handleSelectSale = (saleId, checked) => {
    if (checked) {
      setSelectedSaleIds(prev => [...prev, saleId]);
    } else {
      setSelectedSaleIds(prev => prev.filter(id => id !== saleId));
    }
  };

  const handleBulkStatusUpdate = async () => {
    if (!bulkStatus || selectedSaleIds.length === 0) return;
    try {
      const resp = await fetch('/api/sales/bulk-status', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ saleIds: selectedSaleIds, status: bulkStatus })
      });
      if (!resp.ok) throw new Error('Toplu güncelleme başarısız');
      setShowBulkModal(false);
      setSelectedSaleIds([]);
      setBulkStatus("");
      loadSales();
      showToast(`${selectedSaleIds.length} sipariş başarıyla güncellendi!`);
    } catch (err) {
      showToast('Toplu güncelleme başarısız: ' + err.message, 'error');
    }
  };

  // ======================== ÖDEME DURUMU GÜNCELLE ========================
  const handlePaymentStatusUpdate = async () => {
    if (!detailSale) return;
    try {
      const resp = await fetch(`/api/sales/${detailSale.id}/payment-status`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          payment_type: paymentType,
          payment_status: paymentStatus,
          payment_notes: paymentNotes,
          paid_amount: paidAmount ? parseFloat(paidAmount) : null
        })
      });
      if (!resp.ok) throw new Error('Ödeme durumu güncellenemedi');
      loadSales();
      const updatedResp = await fetch(`/api/sales/${detailSale.id}`);
      const updatedData = await updatedResp.json();
      setDetailSale(updatedData);
      loadActivityLogs(detailSale.id);
      setShowPaymentModal(false);
      setPaymentType("");
      setPaymentStatus("");
      setPaymentNotes("");
      setPaidAmount("");
      showToast('Ödeme durumu başarıyla güncellendi!');
    } catch (err) {
      showToast('Ödeme durumu güncellenemedi: ' + err.message, 'error');
    }
  };

  // ======================== EXCEL DIŞA AKTARMA ========================
  const exportToExcel = () => {
    const data = filteredAndSortedSales.map(sale => ({
      'Satış No': sale.sale_no,
      'Partner': sale.partner_name,
      'Partner Kodu': sale.partner_code,
      'Sipariş Tarihi': sale.order_date ? new Date(sale.order_date).toLocaleDateString('tr-TR') : '-',
      'Teslimat Tarihi': sale.delivery_date ? new Date(sale.delivery_date).toLocaleDateString('tr-TR') : '-',
      'Tutar': sale.total_amount,
      'Para Birimi': sale.currency,
      'Durum': getStatusText(sale.status),
      'Ödeme Türü': sale.payment_type ? getPaymentTypeText(sale.payment_type) : '-',
      'Ödeme Durumu': getPaymentStatusText(sale.payment_status),
      'Gecikme': isOverdue(sale) ? `${daysOverdue(sale)} gün` : '-',
      'Notlar': sale.notes || '-'
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Satışlar");

    // Sütun genişlikleri
    ws['!cols'] = [
      { wch: 15 }, { wch: 25 }, { wch: 12 }, { wch: 14 },
      { wch: 14 }, { wch: 14 }, { wch: 10 }, { wch: 16 },
      { wch: 20 }, { wch: 14 }, { wch: 12 }, { wch: 30 }
    ];

    XLSX.writeFile(wb, `Satislar_${new Date().toISOString().slice(0, 10)}.xlsx`);
    showToast('Excel dosyası indirildi!');
    setShowExportMenu(false);
  };

  // ======================== PDF DIŞA AKTARMA ========================
  const exportToPDF = () => {
    const doc = new jsPDF('l', 'mm', 'a4');

    doc.setFontSize(18);
    doc.setTextColor(30, 58, 138);
    doc.text('Satislar Raporu', 14, 20);

    doc.setFontSize(10);
    doc.setTextColor(100, 100, 100);
    doc.text(`Olusturma Tarihi: ${new Date().toLocaleDateString('tr-TR')}`, 14, 28);
    doc.text(`Toplam: ${filteredAndSortedSales.length} satis`, 14, 34);

    const tableData = filteredAndSortedSales.map(sale => [
      sale.sale_no,
      sale.partner_name,
      sale.order_date ? new Date(sale.order_date).toLocaleDateString('tr-TR') : '-',
      sale.delivery_date ? new Date(sale.delivery_date).toLocaleDateString('tr-TR') : '-',
      `${sale.total_amount?.toLocaleString('tr-TR')} ${sale.currency}`,
      getStatusText(sale.status),
      getPaymentStatusText(sale.payment_status),
      isOverdue(sale) ? `${daysOverdue(sale)} gun gecikme` : '-'
    ]);

    doc.autoTable({
      startY: 40,
      head: [['Satis No', 'Partner', 'Siparis Tarihi', 'Teslimat Tarihi', 'Tutar', 'Durum', 'Odeme', 'Gecikme']],
      body: tableData,
      styles: { fontSize: 8, cellPadding: 3 },
      headStyles: { fillColor: [30, 58, 138], textColor: 255 },
      alternateRowStyles: { fillColor: [240, 245, 255] },
      columnStyles: {
        0: { cellWidth: 28 },
        1: { cellWidth: 40 },
        4: { halign: 'right' },
        7: { textColor: [220, 38, 38] }
      }
    });

    doc.save(`Satislar_${new Date().toISOString().slice(0, 10)}.pdf`);
    showToast('PDF dosyasi indirildi!');
    setShowExportMenu(false);
  };

  // ======================== YARDIMCI FONKSİYONLAR ========================
  const getStatusColor = (status) => {
    switch (status) {
      case 'ordered': return 'bg-blue-100 text-blue-800';
      case 'in_production': return 'bg-yellow-100 text-yellow-800';
      case 'ready_for_delivery': return 'bg-green-100 text-green-800';
      case 'delivered': return 'bg-purple-100 text-purple-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'ordered': return 'Sipariş Verildi';
      case 'in_production': return 'Üretimde';
      case 'ready_for_delivery': return 'Teslime Hazır';
      case 'delivered': return 'Teslim Edildi';
      case 'cancelled': return 'İptal Edildi';
      default: return 'Bilinmiyor';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'ordered': return <HiOutlineClock className="w-4 h-4" />;
      case 'in_production': return <HiOutlineCog className="w-4 h-4" />;
      case 'ready_for_delivery': return <HiOutlineTruck className="w-4 h-4" />;
      case 'delivered': return <HiOutlineCheckCircle className="w-4 h-4" />;
      case 'cancelled': return <HiOutlineX className="w-4 h-4" />;
      default: return <HiOutlineClock className="w-4 h-4" />;
    }
  };

  const getProductionStatusColor = (status) => {
    switch (status) {
      case 'not_started': return 'bg-blue-100 text-blue-800';
      case 'in_progress': return 'bg-yellow-100 text-yellow-800';
      case 'completed': return 'bg-green-100 text-green-800';
      case 'quality_check': return 'bg-blue-100 text-blue-800';
      case 'ready': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getProductionStatusText = (status) => {
    switch (status) {
      case 'not_started': return 'Siparişiniz İşleniyor';
      case 'in_progress': return 'Üretimde';
      case 'completed': return 'Tamamlandı';
      case 'quality_check': return 'Kalite Kontrol';
      case 'ready': return 'Hazır';
      default: return 'Bilinmiyor';
    }
  };

  const getPaymentTypeText = (type) => {
    switch (type) {
      case 'check': return 'Çek ile Ödeme';
      case 'cash': return 'Nakit Ödeme';
      case 'credit_card': return 'Kredi Kartı ile Ödeme';
      case 'eft': return 'EFT ile Ödeme';
      default: return 'Belirtilmemiş';
    }
  };

  const getPaymentStatusText = (status) => {
    switch (status) {
      case 'pending': return 'Beklemede';
      case 'paid': return 'Ödendi';
      case 'partial': return 'Kısmi Ödeme';
      case 'cancelled': return 'İptal Edildi';
      default: return 'Bilinmiyor';
    }
  };

  const getPaymentStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'paid': return 'bg-green-100 text-green-800';
      case 'partial': return 'bg-blue-100 text-blue-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getActivityIcon = (type) => {
    switch (type) {
      case 'status_change': return <HiOutlineSwitchHorizontal className="w-4 h-4 text-blue-600" />;
      case 'payment_update': return <HiOutlineCash className="w-4 h-4 text-green-600" />;
      case 'note': return <HiOutlineChatAlt2 className="w-4 h-4 text-purple-600" />;
      case 'created': return <HiOutlineCheck className="w-4 h-4 text-emerald-600" />;
      default: return <HiOutlineDocumentText className="w-4 h-4 text-gray-600" />;
    }
  };

  // ======================== İSTATİSTİKLER ========================
  const stats = useMemo(() => {
    const totalAmount = sales.reduce((sum, s) => sum + (Number(s.total_amount) || 0), 0);
    const pendingPayment = sales.filter(s => s.payment_status !== 'paid' && s.status !== 'cancelled')
      .reduce((sum, s) => sum + (Number(s.total_amount) || 0), 0);
    const paidTotal = sales.filter(s => s.payment_status === 'paid')
      .reduce((sum, s) => sum + (Number(s.total_amount) || 0), 0);
    return {
      total: sales.length,
      ordered: sales.filter(s => s.status === 'ordered').length,
      inProduction: sales.filter(s => s.status === 'in_production').length,
      readyForDelivery: sales.filter(s => s.status === 'ready_for_delivery').length,
      delivered: sales.filter(s => s.status === 'delivered').length,
      cancelled: sales.filter(s => s.status === 'cancelled').length,
      overdue: overdueCount,
      totalAmount,
      pendingPayment,
      paidTotal
    };
  }, [sales, overdueCount]);

  // Filtreleri temizle
  const clearFilters = () => {
    setSearchTerm("");
    setStatusFilter("all");
    setPartnerFilter("all");
    setDateFrom("");
    setDateTo("");
    setDateField("order_date");
    setCurrentPage(1);
  };

  const hasActiveFilters = searchTerm || statusFilter !== 'all' || partnerFilter !== 'all' || dateFrom || dateTo;

  // ======================== RENDER ========================
  return (
    <div className="w-full p-6">
      {/* Toast Bildirim */}
      {toast && (
        <div className={`fixed top-6 right-6 z-[100] px-5 py-3 rounded-xl shadow-2xl text-white font-semibold text-sm flex items-center gap-2 animate-fade-in transition-all ${
          toast.type === 'error' ? 'bg-red-600' : 'bg-green-600'
        }`}>
          {toast.type === 'error' ? <HiOutlineExclamationCircle className="w-5 h-5" /> : <HiOutlineCheckCircle className="w-5 h-5" />}
          {toast.message}
        </div>
      )}

      <h1 className="text-3xl font-bold text-blue-900 mb-6 flex items-center gap-3 px-6 pt-6">
        <HiOutlineShoppingCart className="w-8 h-8 text-blue-700" /> Satışlar Yönetimi
      </h1>

      {/* ============ GECİKME UYARISI BANNER ============ */}
      {overdueCount > 0 && (
        <div className="mx-6 mb-4 px-5 py-3 bg-red-50 border border-red-200 rounded-xl flex items-center gap-3 animate-pulse">
          <HiOutlineBell className="w-6 h-6 text-red-600 flex-shrink-0" />
          <div>
            <span className="font-bold text-red-800">{overdueCount} sipariş gecikmiş!</span>
            <span className="text-red-700 text-sm ml-2">Teslimat tarihi geçmiş ancak teslim edilmemiş siparişler mevcut.</span>
          </div>
          <button
            className="ml-auto px-3 py-1 rounded-lg bg-red-600 text-white text-xs font-semibold hover:bg-red-700"
            onClick={() => { setStatusFilter("all"); setSearchTerm(""); setDateFrom(""); setDateTo(""); }}
          >
            Tümünü Göster
          </button>
        </div>
      )}

      <div className="bg-white rounded-2xl shadow-xl p-6 flex flex-col gap-5 border border-blue-100 mx-0">
        {/* ============ BAŞLIK BARI ============ */}
        <div className="flex flex-wrap justify-between items-center gap-3">
          <div className="flex items-center gap-3">
            <span className="font-semibold text-blue-800 text-lg">Satış Siparişleri</span>
            <span className="text-sm text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
              {filteredAndSortedSales.length} / {sales.length}
            </span>
          </div>

          <div className="flex gap-2 items-center flex-wrap">
            {/* Toplu İşlem */}
            {selectedSaleIds.length > 0 && (
              <button
                className="px-3 py-2 rounded-lg bg-orange-600 text-white text-xs font-semibold hover:bg-orange-700 flex items-center gap-1"
                onClick={() => setShowBulkModal(true)}
              >
                <HiOutlineClipboardList className="w-4 h-4" />
                {selectedSaleIds.length} Seçili - Toplu İşlem
              </button>
            )}

            {/* Filtre Aç/Kapa */}
            <button
              className={`px-3 py-2 rounded-lg text-xs font-semibold flex items-center gap-1 transition ${
                showFilters ? 'bg-blue-600 text-white' : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
              }`}
              onClick={() => setShowFilters(!showFilters)}
            >
              <HiOutlineFilter className="w-4 h-4" />
              Filtreler
              {hasActiveFilters && <span className="w-2 h-2 bg-red-500 rounded-full" />}
            </button>

            {/* Dışa Aktar */}
            <div className="relative">
              <button
                className="px-3 py-2 rounded-lg bg-green-50 text-green-700 hover:bg-green-100 text-xs font-semibold flex items-center gap-1"
                onClick={() => setShowExportMenu(!showExportMenu)}
              >
                <HiOutlineDocumentDownload className="w-4 h-4" />
                Dışa Aktar
                <HiOutlineChevronDown className="w-3 h-3" />
              </button>
              {showExportMenu && (
                <div className="absolute right-0 top-full mt-1 bg-white border border-gray-200 rounded-xl shadow-lg py-2 z-30 min-w-[160px]">
                  <button
                    className="w-full text-left px-4 py-2 text-sm hover:bg-green-50 text-gray-700 flex items-center gap-2"
                    onClick={exportToExcel}
                  >
                    <HiOutlineDocumentDownload className="w-4 h-4 text-green-600" />
                    Excel (.xlsx)
                  </button>
                  <button
                    className="w-full text-left px-4 py-2 text-sm hover:bg-red-50 text-gray-700 flex items-center gap-2"
                    onClick={exportToPDF}
                  >
                    <HiOutlineDocumentText className="w-4 h-4 text-red-600" />
                    PDF (.pdf)
                  </button>
                </div>
              )}
            </div>

            {/* Yenile */}
            <button
              className="px-3 py-2 rounded-lg bg-gray-50 text-gray-700 hover:bg-gray-100 text-xs font-semibold flex items-center gap-1"
              onClick={loadSales}
            >
              <HiOutlineRefresh className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* ============ FİLTRE PANELİ ============ */}
        {showFilters && (
          <div className="bg-blue-50/50 rounded-xl p-4 border border-blue-100 animate-fade-in">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Arama */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Arama</label>
                <input
                  type="text"
                  placeholder="Satış no, partner adı, not..."
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {/* Durum Filtresi */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Durum</label>
                <select
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="all">Tüm Durumlar</option>
                  <option value="ordered">Sipariş Verildi</option>
                  <option value="in_production">Üretimde</option>
                  <option value="ready_for_delivery">Teslime Hazır</option>
                  <option value="delivered">Teslim Edildi</option>
                  <option value="cancelled">İptal Edildi</option>
                </select>
              </div>

              {/* Partner Filtresi */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Partner</label>
                <select
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={partnerFilter}
                  onChange={(e) => setPartnerFilter(e.target.value)}
                >
                  <option value="all">Tüm Partnerler</option>
                  {partners.map(partner => (
                    <option key={partner.id} value={partner.id}>{partner.name}</option>
                  ))}
                </select>
              </div>

              {/* Tarih Alanı Seçimi */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Tarih Alanı</label>
                <select
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={dateField}
                  onChange={(e) => setDateField(e.target.value)}
                >
                  <option value="order_date">Sipariş Tarihi</option>
                  <option value="delivery_date">Teslimat Tarihi</option>
                </select>
              </div>

              {/* Başlangıç Tarihi */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Başlangıç Tarihi</label>
                <input
                  type="date"
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </div>

              {/* Bitiş Tarihi */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Bitiş Tarihi</label>
                <input
                  type="date"
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>

              {/* Sayfa Boyutu */}
              <div className="flex flex-col">
                <label className="text-xs font-semibold text-blue-900 mb-1">Sayfa Boyutu</label>
                <select
                  className="px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-300 text-blue-900 text-sm"
                  value={itemsPerPage}
                  onChange={(e) => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>

              {/* Filtreleri Temizle */}
              <div className="flex flex-col justify-end">
                {hasActiveFilters && (
                  <button
                    className="px-3 py-2 rounded-lg bg-red-50 text-red-700 hover:bg-red-100 text-sm font-semibold flex items-center gap-1"
                    onClick={clearFilters}
                  >
                    <HiOutlineX className="w-4 h-4" />
                    Filtreleri Temizle
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ============ SATIŞ TABLOSU ============ */}
        <div className="overflow-x-auto rounded-xl border border-blue-100">
          <table className="min-w-full text-sm">
            <thead className="bg-blue-50">
              <tr className="text-blue-900">
                {/* Checkbox */}
                <th className="px-3 py-3 text-left w-10">
                  <input
                    type="checkbox"
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    checked={paginatedSales.length > 0 && selectedSaleIds.length === paginatedSales.length}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                  />
                </th>
                {/* Satış No */}
                <th className="px-3 py-3 text-left cursor-pointer hover:bg-blue-100 transition select-none" onClick={() => handleSort('sale_no')}>
                  <div className="flex items-center">Satış No <SortIcon field="sale_no" /></div>
                </th>
                {/* Partner */}
                <th className="px-3 py-3 text-left cursor-pointer hover:bg-blue-100 transition select-none" onClick={() => handleSort('partner_name')}>
                  <div className="flex items-center">Partner <SortIcon field="partner_name" /></div>
                </th>
                {/* Sipariş Tarihi */}
                <th className="px-3 py-3 text-left cursor-pointer hover:bg-blue-100 transition select-none" onClick={() => handleSort('order_date')}>
                  <div className="flex items-center">Sipariş Tarihi <SortIcon field="order_date" /></div>
                </th>
                {/* Teslimat Tarihi */}
                <th className="px-3 py-3 text-left cursor-pointer hover:bg-blue-100 transition select-none" onClick={() => handleSort('delivery_date')}>
                  <div className="flex items-center">Teslimat Tarihi <SortIcon field="delivery_date" /></div>
                </th>
                {/* Tutar */}
                <th className="px-3 py-3 text-left cursor-pointer hover:bg-blue-100 transition select-none" onClick={() => handleSort('total_amount')}>
                  <div className="flex items-center">Tutar <SortIcon field="total_amount" /></div>
                </th>
                {/* Ödeme */}
                <th className="px-3 py-3 text-left">Ödeme</th>
                {/* Durum */}
                <th className="px-3 py-3 text-left">Durum</th>
                {/* İşlemler */}
                <th className="px-3 py-3 text-left">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSales.length === 0 && (
                <tr><td colSpan={9} className="text-center text-gray-400 py-8">
                  <HiOutlineShoppingCart className="w-12 h-12 mx-auto mb-2 text-gray-300" />
                  Hiç satış bulunamadı.
                </td></tr>
              )}
              {paginatedSales.map(sale => {
                const overdue = isOverdue(sale);
                const overdueDays = daysOverdue(sale);
                return (
                  <tr
                    key={sale.id}
                    className={`transition border-b border-gray-50 ${
                      overdue ? 'bg-red-50/60 hover:bg-red-50' : 'hover:bg-blue-50/60'
                    } ${selectedSaleIds.includes(sale.id) ? 'bg-blue-50' : ''}`}
                  >
                    {/* Checkbox */}
                    <td className="px-3 py-2">
                      <input
                        type="checkbox"
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                        checked={selectedSaleIds.includes(sale.id)}
                        onChange={(e) => handleSelectSale(sale.id, e.target.checked)}
                      />
                    </td>

                    {/* Satış No */}
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-2">
                        <span className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold ${
                          overdue ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
                        }`}>
                          {overdue ? <HiOutlineExclamationCircle className="w-4 h-4" /> : <HiOutlineShoppingCart className="w-4 h-4" />}
                        </span>
                        <div>
                          <span className="font-mono font-semibold">{sale.sale_no}</span>
                          {overdue && (
                            <div className="text-xs text-red-600 font-semibold flex items-center gap-1">
                              <HiOutlineBell className="w-3 h-3" />
                              {overdueDays} gün gecikmiş!
                            </div>
                          )}
                        </div>
                      </div>
                    </td>

                    {/* Partner */}
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-2">
                        <span className="w-6 h-6 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-xs font-bold">
                          <HiOutlineUserGroup className="w-3 h-3" />
                        </span>
                        <div>
                          <div className="font-semibold text-sm">{sale.partner_name}</div>
                          <div className="text-xs text-gray-500">{sale.partner_code}</div>
                        </div>
                      </div>
                    </td>

                    {/* Sipariş Tarihi */}
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1 text-sm">
                        <HiOutlineCalendar className="w-4 h-4 text-blue-400" />
                        {new Date(sale.order_date).toLocaleDateString('tr-TR')}
                      </div>
                    </td>

                    {/* Teslimat Tarihi */}
                    <td className="px-3 py-2">
                      {sale.delivery_date ? (
                        <div className={`flex items-center gap-1 text-sm ${overdue ? 'text-red-600 font-semibold' : ''}`}>
                          <HiOutlineCalendar className={`w-4 h-4 ${overdue ? 'text-red-500' : 'text-green-400'}`} />
                          {new Date(sale.delivery_date).toLocaleDateString('tr-TR')}
                        </div>
                      ) : (
                        <span className="text-gray-400">-</span>
                      )}
                    </td>

                    {/* Tutar */}
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-1">
                        <HiOutlineCurrencyDollar className="w-4 h-4 text-green-400" />
                        <span className="font-semibold">{Number(sale.total_amount)?.toLocaleString('tr-TR')} {sale.currency}</span>
                      </div>
                    </td>

                    {/* Ödeme Durumu */}
                    <td className="px-3 py-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getPaymentStatusColor(sale.payment_status)}`}>
                        {getPaymentStatusText(sale.payment_status)}
                      </span>
                    </td>

                    {/* Durum - Inline Değiştirme */}
                    <td className="px-3 py-2">
                      <select
                        className={`px-2 py-1 rounded-lg text-xs font-semibold border-0 cursor-pointer focus:ring-2 focus:ring-blue-300 ${getStatusColor(sale.status)} ${
                          statusUpdating === sale.id ? 'opacity-50' : ''
                        }`}
                        value={sale.status}
                        onChange={(e) => handleInlineStatusChange(sale.id, e.target.value)}
                        disabled={statusUpdating === sale.id}
                      >
                        <option value="ordered">Sipariş Verildi</option>
                        <option value="in_production">Üretimde</option>
                        <option value="ready_for_delivery">Teslime Hazır</option>
                        <option value="delivered">Teslim Edildi</option>
                        <option value="cancelled">İptal Edildi</option>
                      </select>
                    </td>

                    {/* İşlemler */}
                    <td className="px-3 py-2">
                      <button
                        className="px-2 py-1 rounded bg-blue-100 text-blue-700 hover:bg-blue-200 text-xs font-semibold flex items-center gap-1"
                        onClick={() => handleShowDetail(sale)}
                      >
                        <HiOutlineEye className="w-4 h-4" /> Detay
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* ============ SAYFALAMA ============ */}
        {totalPages > 1 && (
          <div className="flex items-center justify-between px-2 pt-2">
            <div className="text-sm text-gray-500">
              {(currentPage - 1) * itemsPerPage + 1} - {Math.min(currentPage * itemsPerPage, filteredAndSortedSales.length)} / {filteredAndSortedSales.length} kayıt
            </div>
            <div className="flex items-center gap-1">
              <button
                className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setCurrentPage(1)}
                disabled={currentPage === 1}
              >
                İlk
              </button>
              <button
                className="px-2 py-1.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setCurrentPage(p => p - 1)}
                disabled={currentPage === 1}
              >
                <HiOutlineChevronLeft className="w-4 h-4" />
              </button>

              {/* Sayfa numaraları */}
              {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                let pageNum;
                if (totalPages <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= totalPages - 2) {
                  pageNum = totalPages - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }
                return (
                  <button
                    key={pageNum}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium ${
                      currentPage === pageNum
                        ? 'bg-blue-600 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                    onClick={() => setCurrentPage(pageNum)}
                  >
                    {pageNum}
                  </button>
                );
              })}

              <button
                className="px-2 py-1.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setCurrentPage(p => p + 1)}
                disabled={currentPage === totalPages}
              >
                <HiOutlineChevronRight className="w-4 h-4" />
              </button>
              <button
                className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 text-sm disabled:opacity-40 disabled:cursor-not-allowed"
                onClick={() => setCurrentPage(totalPages)}
                disabled={currentPage === totalPages}
              >
                Son
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ============ DETAY MODALI ============ */}
      {showDetail && detailSale && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50" onClick={(e) => { if (e.target === e.currentTarget) setShowDetail(false); }}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl flex flex-col border border-blue-100 animate-fade-in max-h-[92vh] overflow-hidden">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-blue-100 bg-gradient-to-r from-blue-50 to-white">
              <div className="flex items-center gap-3">
                <HiOutlineShoppingCart className="w-7 h-7 text-blue-700" />
                <div>
                  <h2 className="text-xl font-bold text-blue-900">Satış Detayı</h2>
                  <span className="text-sm text-gray-500 font-mono">{detailSale.sale_no}</span>
                </div>
                {isOverdue(detailSale) && (
                  <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-bold flex items-center gap-1 animate-pulse">
                    <HiOutlineBell className="w-3 h-3" />
                    {daysOverdue(detailSale)} gün gecikmiş
                  </span>
                )}
              </div>
              <button className="p-2 rounded-lg hover:bg-gray-100 transition" onClick={() => setShowDetail(false)}>
                <HiOutlineX className="w-5 h-5 text-gray-500" />
              </button>
            </div>

            {/* Sipariş Durumu Timeline */}
            <div className="px-6 py-4 border-b border-blue-50 bg-gray-50/50">
              <div className="flex items-center justify-between max-w-3xl mx-auto">
                {['ordered', 'in_production', 'ready_for_delivery', 'delivered'].map((step, idx) => {
                  const steps = ['ordered', 'in_production', 'ready_for_delivery', 'delivered'];
                  const currentIdx = steps.indexOf(detailSale.status);
                  const isActive = idx <= currentIdx;
                  const isCurrent = step === detailSale.status;
                  const isCancelled = detailSale.status === 'cancelled';
                  return (
                    <React.Fragment key={step}>
                      <div className="flex flex-col items-center">
                        <div className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all ${
                          isCancelled ? 'bg-red-100 text-red-600' :
                          isCurrent ? 'bg-blue-600 text-white ring-4 ring-blue-200' :
                          isActive ? 'bg-green-500 text-white' : 'bg-gray-200 text-gray-500'
                        }`}>
                          {isCancelled ? <HiOutlineX className="w-5 h-5" /> :
                           isActive && !isCurrent ? <HiOutlineCheck className="w-5 h-5" /> :
                           getStatusIcon(step)}
                        </div>
                        <span className={`text-xs mt-1 font-medium ${
                          isCurrent ? 'text-blue-700' : isActive ? 'text-green-700' : 'text-gray-400'
                        }`}>
                          {getStatusText(step)}
                        </span>
                      </div>
                      {idx < 3 && (
                        <div className={`flex-1 h-1 mx-2 rounded ${
                          isCancelled ? 'bg-red-200' :
                          idx < currentIdx ? 'bg-green-400' : 'bg-gray-200'
                        }`} />
                      )}
                    </React.Fragment>
                  );
                })}
              </div>
              {detailSale.status === 'cancelled' && (
                <div className="text-center mt-2 text-red-600 text-xs font-semibold">Bu sipariş iptal edilmiştir</div>
              )}
            </div>

            {/* Sekmeler */}
            <div className="flex border-b border-gray-200 px-6">
              {[
                { id: 'info', label: 'Genel Bilgiler', icon: <HiOutlineClipboardList className="w-4 h-4" /> },
                { id: 'items', label: 'Ürünler', icon: <HiOutlineShoppingCart className="w-4 h-4" /> },
                { id: 'payments', label: 'Ödeme Takip', icon: <HiOutlineCash className="w-4 h-4" /> },
                { id: 'history', label: 'Aktivite Geçmişi', icon: <HiOutlineChatAlt2 className="w-4 h-4" /> }
              ].map(tab => (
                <button
                  key={tab.id}
                  className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                    detailTab === tab.id
                      ? 'border-blue-600 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700'
                  }`}
                  onClick={() => setDetailTab(tab.id)}
                >
                  {tab.icon}
                  {tab.label}
                  {tab.id === 'history' && activityLogs.length > 0 && (
                    <span className="bg-blue-100 text-blue-700 text-xs px-1.5 py-0.5 rounded-full">{activityLogs.length}</span>
                  )}
                </button>
              ))}
            </div>

            {/* Sekme İçeriği */}
            <div className="flex-1 overflow-y-auto p-6">
              {/* ---- GENEL BİLGİLER ---- */}
              {detailTab === 'info' && (
                <div className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <InfoCard label="Satış No" value={detailSale.sale_no} icon={<HiOutlineShoppingCart className="w-4 h-4 text-blue-600" />} />
                    <InfoCard label="Partner" value={`${detailSale.partner_name} (${detailSale.partner_code})`} icon={<HiOutlineUserGroup className="w-4 h-4 text-blue-600" />} />
                    <InfoCard label="Sipariş Tarihi" value={new Date(detailSale.order_date).toLocaleDateString('tr-TR')} icon={<HiOutlineCalendar className="w-4 h-4 text-blue-600" />} />
                    <InfoCard label="Teslimat Tarihi" value={detailSale.delivery_date ? new Date(detailSale.delivery_date).toLocaleDateString('tr-TR') : '-'} icon={<HiOutlineCalendar className="w-4 h-4 text-green-600" />} />
                    <InfoCard label="Toplam Tutar" value={`${Number(detailSale.total_amount)?.toLocaleString('tr-TR')} ${detailSale.currency}`} icon={<HiOutlineCurrencyDollar className="w-4 h-4 text-green-600" />} />
                    <InfoCard label="Durum" value={<span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(detailSale.status)}`}>{getStatusText(detailSale.status)}</span>} icon={getStatusIcon(detailSale.status)} />
                    <InfoCard label="Ödeme Türü" value={detailSale.payment_type ? getPaymentTypeText(detailSale.payment_type) : 'Belirtilmemiş'} icon={<HiOutlineCash className="w-4 h-4 text-purple-600" />} />
                    <InfoCard label="Ödeme Durumu" value={<span className={`px-2 py-1 rounded-full text-xs font-semibold ${getPaymentStatusColor(detailSale.payment_status)}`}>{getPaymentStatusText(detailSale.payment_status)}</span>} icon={<HiOutlineCurrencyDollar className="w-4 h-4 text-yellow-600" />} />
                    <InfoCard label="Oluşturulma" value={new Date(detailSale.created_at).toLocaleDateString('tr-TR')} icon={<HiOutlineClock className="w-4 h-4 text-gray-600" />} />
                  </div>
                  {detailSale.notes && (
                    <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
                      <div className="text-xs font-semibold text-yellow-800 mb-1 flex items-center gap-1">
                        <HiOutlineDocumentText className="w-4 h-4" /> Sipariş Notları
                      </div>
                      <p className="text-sm text-yellow-900">{detailSale.notes}</p>
                    </div>
                  )}
                  {detailSale.payment_notes && (
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                      <div className="text-xs font-semibold text-blue-800 mb-1 flex items-center gap-1">
                        <HiOutlineCash className="w-4 h-4" /> Ödeme Notları
                      </div>
                      <p className="text-sm text-blue-900">{detailSale.payment_notes}</p>
                    </div>
                  )}
                </div>
              )}

              {/* ---- ÜRÜNLER ---- */}
              {detailTab === 'items' && (
                <div>
                  <div className="overflow-x-auto rounded-xl border border-blue-100">
                    <table className="min-w-full text-sm">
                      <thead className="bg-blue-50">
                        <tr className="text-blue-900">
                          <th className="px-3 py-2 text-left">Ürün</th>
                          <th className="px-3 py-2 text-left">Kod</th>
                          <th className="px-3 py-2 text-left">Miktar</th>
                          <th className="px-3 py-2 text-left">Promosyon</th>
                          <th className="px-3 py-2 text-left">Birim Fiyat</th>
                          <th className="px-3 py-2 text-left">Toplam</th>
                          <th className="px-3 py-2 text-left">Üretim Durumu</th>
                          <th className="px-3 py-2 text-left">Notlar</th>
                        </tr>
                      </thead>
                      <tbody>
                        {detailSale.items?.map(item => (
                          <tr key={item.id} className="hover:bg-blue-50 transition border-b border-gray-50">
                            <td className="px-3 py-2 font-semibold">{item.product_name}</td>
                            <td className="px-3 py-2 font-mono text-xs">{item.product_code}</td>
                            <td className="px-3 py-2">{item.quantity}</td>
                            <td className="px-3 py-2">
                              {item.promotion_quantity ? (
                                <span className="px-2 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                                  +{item.promotion_quantity} adet
                                </span>
                              ) : <span className="text-gray-400">-</span>}
                            </td>
                            <td className="px-3 py-2">{Number(item.unit_price)?.toLocaleString('tr-TR')} {detailSale.currency}</td>
                            <td className="px-3 py-2 font-semibold">{Number(item.total_price)?.toLocaleString('tr-TR')} {detailSale.currency}</td>
                            <td className="px-3 py-2">
                              <span className={`px-2 py-1 rounded-full text-xs font-semibold ${getProductionStatusColor(item.production_status)}`}>
                                {getProductionStatusText(item.production_status)}
                              </span>
                            </td>
                            <td className="px-3 py-2 text-xs text-gray-500">{item.production_notes || '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                      <tfoot className="bg-blue-50/50 border-t border-blue-200">
                        <tr>
                          <td colSpan={5} className="px-3 py-2 text-right font-semibold text-blue-900">Genel Toplam:</td>
                          <td className="px-3 py-2 font-bold text-blue-900">
                            {Number(detailSale.total_amount)?.toLocaleString('tr-TR')} {detailSale.currency}
                          </td>
                          <td colSpan={2}></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              )}

              {/* ---- ÖDEME TAKİP PANELİ ---- */}
              {detailTab === 'payments' && (
                <div className="space-y-6">
                  {/* Ödeme Özeti Kartları */}
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border border-blue-200">
                      <div className="text-xs font-semibold text-blue-700 mb-1">Toplam Tutar</div>
                      <div className="text-2xl font-bold text-blue-900">
                        {Number(detailSale.total_amount)?.toLocaleString('tr-TR')} {detailSale.currency}
                      </div>
                    </div>
                    <div className={`rounded-xl p-4 border ${
                      detailSale.payment_status === 'paid'
                        ? 'bg-gradient-to-br from-green-50 to-green-100 border-green-200'
                        : 'bg-gradient-to-br from-yellow-50 to-yellow-100 border-yellow-200'
                    }`}>
                      <div className={`text-xs font-semibold mb-1 ${detailSale.payment_status === 'paid' ? 'text-green-700' : 'text-yellow-700'}`}>Ödenen Tutar</div>
                      <div className={`text-2xl font-bold ${detailSale.payment_status === 'paid' ? 'text-green-900' : 'text-yellow-900'}`}>
                        {detailSale.payment_status === 'paid'
                          ? `${Number(detailSale.total_amount)?.toLocaleString('tr-TR')} ${detailSale.currency}`
                          : detailSale.paid_amount
                            ? `${Number(detailSale.paid_amount)?.toLocaleString('tr-TR')} ${detailSale.currency}`
                            : `0 ${detailSale.currency}`
                        }
                      </div>
                    </div>
                    <div className={`rounded-xl p-4 border ${
                      detailSale.payment_status === 'paid'
                        ? 'bg-gradient-to-br from-green-50 to-green-100 border-green-200'
                        : 'bg-gradient-to-br from-red-50 to-red-100 border-red-200'
                    }`}>
                      <div className={`text-xs font-semibold mb-1 ${detailSale.payment_status === 'paid' ? 'text-green-700' : 'text-red-700'}`}>Kalan Tutar</div>
                      <div className={`text-2xl font-bold ${detailSale.payment_status === 'paid' ? 'text-green-900' : 'text-red-900'}`}>
                        {detailSale.payment_status === 'paid'
                          ? `0 ${detailSale.currency}`
                          : `${(Number(detailSale.total_amount) - (Number(detailSale.paid_amount) || 0))?.toLocaleString('tr-TR')} ${detailSale.currency}`
                        }
                      </div>
                    </div>
                  </div>

                  {/* Ödeme İlerleme Çubuğu */}
                  <div className="bg-white border border-gray-200 rounded-xl p-4">
                    <div className="flex items-center justify-between mb-2">
                      <span className="text-sm font-semibold text-gray-700">Ödeme İlerlemesi</span>
                      <span className="text-sm text-gray-500">
                        {detailSale.payment_status === 'paid' ? '100' :
                          detailSale.paid_amount ? Math.round((Number(detailSale.paid_amount) / Number(detailSale.total_amount)) * 100) : 0}%
                      </span>
                    </div>
                    <div className="w-full h-4 bg-gray-200 rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full transition-all duration-500 ${
                          detailSale.payment_status === 'paid' ? 'bg-green-500' :
                          detailSale.payment_status === 'partial' ? 'bg-yellow-500' : 'bg-gray-300'
                        }`}
                        style={{
                          width: `${detailSale.payment_status === 'paid' ? 100 :
                            detailSale.paid_amount ? Math.min(100, Math.round((Number(detailSale.paid_amount) / Number(detailSale.total_amount)) * 100)) : 0}%`
                        }}
                      />
                    </div>
                  </div>

                  {/* Ödeme Detayları */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <InfoCard label="Ödeme Türü" value={detailSale.payment_type ? getPaymentTypeText(detailSale.payment_type) : 'Belirtilmemiş'} icon={<HiOutlineCash className="w-4 h-4 text-purple-600" />} />
                    <InfoCard label="Ödeme Durumu" value={<span className={`px-2 py-1 rounded-full text-xs font-semibold ${getPaymentStatusColor(detailSale.payment_status)}`}>{getPaymentStatusText(detailSale.payment_status)}</span>} icon={<HiOutlineCurrencyDollar className="w-4 h-4 text-yellow-600" />} />
                  </div>

                  {detailSale.payment_notes && (
                    <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
                      <div className="text-xs font-semibold text-blue-800 mb-1">Ödeme Notları</div>
                      <p className="text-sm text-blue-900">{detailSale.payment_notes}</p>
                    </div>
                  )}

                  <button
                    className="w-full px-4 py-3 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition font-semibold flex items-center justify-center gap-2"
                    onClick={() => {
                      setPaymentType(detailSale.payment_type || '');
                      setPaymentStatus(detailSale.payment_status || 'pending');
                      setPaymentNotes(detailSale.payment_notes || '');
                      setPaidAmount(detailSale.paid_amount?.toString() || '');
                      setShowPaymentModal(true);
                    }}
                  >
                    <HiOutlinePencil className="w-5 h-5" />
                    Ödeme Durumunu Güncelle
                  </button>
                </div>
              )}

              {/* ---- AKTİVİTE GEÇMİŞİ ---- */}
              {detailTab === 'history' && (
                <div className="space-y-4">
                  {/* Not Ekleme */}
                  <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
                    <label className="text-sm font-semibold text-gray-700 mb-2 block">Yeni Not Ekle</label>
                    <div className="flex gap-2">
                      <input
                        type="text"
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-300"
                        placeholder="Sipariş ile ilgili bir not ekleyin..."
                        value={newNote}
                        onChange={(e) => setNewNote(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleAddNote()}
                      />
                      <button
                        className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-semibold disabled:opacity-40"
                        onClick={handleAddNote}
                        disabled={!newNote.trim()}
                      >
                        Ekle
                      </button>
                    </div>
                  </div>

                  {/* Aktivite Listesi */}
                  {activityLogs.length > 0 ? (
                    <div className="space-y-3">
                      {activityLogs.map((log, idx) => (
                        <div key={log.id || idx} className="flex gap-3 items-start">
                          <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                            {getActivityIcon(log.type)}
                          </div>
                          <div className="flex-1 bg-white border border-gray-200 rounded-xl p-3">
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm font-semibold text-gray-800">{log.description || log.note}</span>
                              <span className="text-xs text-gray-400">
                                {log.created_at ? new Date(log.created_at).toLocaleString('tr-TR') : '-'}
                              </span>
                            </div>
                            {log.old_value && log.new_value && (
                              <div className="text-xs text-gray-500 flex items-center gap-1">
                                <span className="px-1.5 py-0.5 bg-red-50 text-red-700 rounded">{log.old_value}</span>
                                <HiOutlineArrowRight className="w-3 h-3" />
                                <span className="px-1.5 py-0.5 bg-green-50 text-green-700 rounded">{log.new_value}</span>
                              </div>
                            )}
                            {log.user_name && (
                              <div className="text-xs text-gray-400 mt-1">- {log.user_name}</div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-12 text-gray-400">
                      <HiOutlineChatAlt2 className="w-12 h-12 mx-auto mb-2" />
                      <p>Henüz aktivite geçmişi bulunmuyor</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ============ ÖDEME DURUMU GÜNCELLEME MODALI ============ */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[60]">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md flex flex-col gap-4 border border-blue-100 animate-fade-in">
            <div className="text-xl font-bold text-blue-900 text-center mb-2 flex items-center gap-2 justify-center">
              <HiOutlineCash className="w-6 h-6 text-blue-700" />
              Ödeme Durumu Güncelle
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-blue-900 mb-1">Ödeme Türü</label>
                <select
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                  className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400 text-blue-900 bg-white shadow-sm"
                >
                  <option value="">Ödeme Türü Seçin</option>
                  <option value="check">Çek ile Ödeme</option>
                  <option value="cash">Nakit Ödeme</option>
                  <option value="credit_card">Kredi Kartı ile Ödeme</option>
                  <option value="eft">EFT ile Ödeme</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-semibold text-blue-900 mb-1">Ödeme Durumu</label>
                <select
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}
                  className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400 text-blue-900 bg-white shadow-sm"
                >
                  <option value="pending">Beklemede</option>
                  <option value="paid">Ödendi</option>
                  <option value="partial">Kısmi Ödeme</option>
                  <option value="cancelled">İptal Edildi</option>
                </select>
              </div>

              {/* YENİ: Kısmi ödeme tutarı */}
              {paymentStatus === 'partial' && (
                <div>
                  <label className="block text-sm font-semibold text-blue-900 mb-1">Ödenen Tutar</label>
                  <div className="relative">
                    <input
                      type="number"
                      value={paidAmount}
                      onChange={(e) => setPaidAmount(e.target.value)}
                      className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400 text-blue-900 bg-white shadow-sm pr-12"
                      placeholder="Ödenen tutar girin..."
                      min="0"
                      step="0.01"
                    />
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm">{detailSale?.currency}</span>
                  </div>
                  {detailSale && (
                    <div className="text-xs text-gray-500 mt-1">
                      Toplam: {Number(detailSale.total_amount)?.toLocaleString('tr-TR')} {detailSale.currency}
                      {paidAmount && (
                        <> | Kalan: {(Number(detailSale.total_amount) - Number(paidAmount))?.toLocaleString('tr-TR')} {detailSale.currency}</>
                      )}
                    </div>
                  )}
                </div>
              )}

              <div>
                <label className="block text-sm font-semibold text-blue-900 mb-1">Ödeme Notları</label>
                <textarea
                  value={paymentNotes}
                  onChange={(e) => setPaymentNotes(e.target.value)}
                  className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400 text-blue-900 bg-white shadow-sm resize-none"
                  rows={3}
                  placeholder="Ödeme ile ilgili notlar..."
                />
              </div>
            </div>

            <div className="flex gap-3 mt-2">
              <button
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold"
                onClick={handlePaymentStatusUpdate}
              >
                Güncelle
              </button>
              <button
                className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-semibold"
                onClick={() => {
                  setShowPaymentModal(false);
                  setPaymentType("");
                  setPaymentStatus("");
                  setPaymentNotes("");
                  setPaidAmount("");
                }}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ============ TOPLU İŞLEM MODALI ============ */}
      {showBulkModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md border border-blue-100 animate-fade-in">
            <div className="text-xl font-bold text-blue-900 mb-4 flex items-center gap-2">
              <HiOutlineClipboardList className="w-6 h-6 text-blue-700" />
              Toplu İşlem
            </div>

            <div className="bg-blue-50 rounded-xl p-3 mb-4">
              <span className="text-sm text-blue-800 font-semibold">{selectedSaleIds.length} sipariş seçildi</span>
            </div>

            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-blue-900 mb-1">Yeni Durum</label>
                <select
                  value={bulkStatus}
                  onChange={(e) => setBulkStatus(e.target.value)}
                  className="w-full px-3 py-2 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-400 text-blue-900 bg-white"
                >
                  <option value="">Durum Seçin</option>
                  <option value="ordered">Sipariş Verildi</option>
                  <option value="in_production">Üretimde</option>
                  <option value="ready_for_delivery">Teslime Hazır</option>
                  <option value="delivered">Teslim Edildi</option>
                  <option value="cancelled">İptal Edildi</option>
                </select>
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button
                className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold disabled:opacity-40"
                onClick={handleBulkStatusUpdate}
                disabled={!bulkStatus}
              >
                {selectedSaleIds.length} Siparişi Güncelle
              </button>
              <button
                className="flex-1 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition font-semibold"
                onClick={() => { setShowBulkModal(false); setBulkStatus(""); }}
              >
                İptal
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ======================== YARDIMCI BİLEŞEN ========================
function InfoCard({ label, value, icon }) {
  return (
    <div className="bg-gray-50 rounded-xl p-3 border border-gray-100">
      <div className="flex items-center gap-1.5 mb-1">
        {icon}
        <span className="text-xs font-semibold text-gray-500">{label}</span>
      </div>
      <div className="text-sm font-medium text-gray-900">{value}</div>
    </div>
  );
}
